"use client"

import { TicketMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TicketMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TicketMinusIcon = component(Icon)({ as: TicketMinus })
